import React, { ReactElement } from 'react'

import { Col, PageHeader, Row } from 'antd'

const ModalAjudaConfiguracaoArmazem = (): ReactElement => {
  return (
    <Row>
      <Col span={24}>
        <div style={{ fontSize: '16px' }}>
          A modal de configurações de armazéns dos Docas permite configurar e
          determinar alguns parâmetros para cada armazém individualmente. Como
          por exemplo: número de Docas, quantidade de janelas, tamanho de
          janelas secundarias, vincular grupos de usuários ao armazém etc.
          <br />
          <br />
          <span style={{ fontWeight: 'bold' }}>Botões de configuração:</span>
          <br />
          → Editar Armazém: onde se faz toda configuração do armazém escolhido.
          <br />
          → Liberar Agenda: escolhe-se uma data para liberar a agenda.
          <br />
          → Bloquear Agenda: escolhe-se uma data para bloquear na agenda.
          <br />
          <br />
          <span style={{ fontWeight: 'bold' }}>Editar Armazém:</span>
          <br />
          Clicando no botão com forma de lápis abrirá todas as opções de
          configuração do armazém escolhido. Primeiro deve-se escolher a data
          para ajustar as configurações do armazém.
          <br />
          <span style={{ fontWeight: 'bold' }}>Importante: </span>A data a se
          escolher deve ser obrigatoriamente para um dia sem a agenda liberada.
          No caso específico da Adami, além da agenda liberada, a alteração da
          configuração só pode ser feita 5 dias após a data atual. Toda as vezes
          que se queira alterar a configuração do armazém e já se tenha uma
          configuração anterior que irá entrar me vigor, o sistema alertara que
          a configuração mais antiga será sobescrita.
          <br />
          <br />
          <span style={{ fontWeight: 'bold' }}>Demais configurações:</span>
          <br />
          → Nome do Armazém;
          <br />
          → Tipo de Armazém: Expedição ou Biomassa;
          <br />
          → Gerencia Cota: Sim ou Não
          <br />
          → Número de Docas;
          <br />
          → Horário de Funcionamento;
          <br />
          → Quantidade de Janelas Primárias: As opções são calculadas
          automaticamente de acordo com o horário de funcionamento
          <br />
          → Tamanho das Janelas Secundárias: De 15 minutos a 2 horas, onde cada
          opção é um número múltiplo de 15
          <br />
          → Tipo de Macro: Simples, Portaria, Expedição e Avançado.
          <br />
          <br />
          <span style={{ fontWeight: 'bold' }}>
            Configuração de macros específicas:
          </span>
          <br />
          → Pode-se configurar as Macros que podem ser usadas no Armazém. Se
          esta opção não for ajustada as regras que que determina as Macros que
          o usuário poderá usar são as determinadas pelo Grupo de Usuários.
          <br />
          → Usando o botão “Adicionar Macro” pode-se incluir novas Macros e
          determinar se ela será obrigatória ou não usando o checkbox.
          <br />
          → Opções disponíveis na grid:
          <br />
          <ul>
            <li>Setas: alteram a ordem lógica das macros</li>
            <li>Triângulo com exclamação: altera a obrigatoriedade da macro</li>
            <li>Lixeira: remove a macro</li>
          </ul>
          <span style={{ fontWeight: 'bold' }}>
            Configurações que não dependem da data selecionada e que são
            aplicadas imediatamente:
          </span>
          <br />
          → Vincular Grupos de Usuário: determina quais grupos podem visualizar
          o armazém.
          <br />
          → Situação: define se o armazém está ativo ou inativo.
          <br />
          <br />
          <span style={{ fontWeight: 'bold' }}>
            Após concluir a configuração do armazém, clique no botão Salvar.
          </span>
        </div>
      </Col>
    </Row>
  )
}

export default ModalAjudaConfiguracaoArmazem
